import React, { useCallback } from "react";
import { Container, Content } from "./style";
import { useSearchParams } from "react-router-dom";
import { IReservation } from "./interfaces";
import { Start } from "./steps/start";
import { Finish } from "./steps/finish";
import { ConfirmationStep } from "./steps/confirmation";
import { useApiWebCheckinUser } from "../../../hooks/WebCheckinUsers/api";
import { useTheme } from "../../../hooks/WebCheckinUsers/theme";
import { useGlobalWebCheckinUser } from "../../../hooks/WebCheckinUsers/global";
import { MyCircularProgress } from "../../../components/MyCircularProgress";
import { IconPowered } from "../../../components/SvgComponents/Icons/IconPowered";

export const WebCheckOut: React.FC = () => {
  const [step, setStep] = React.useState<
    "start" | "confirmation-steps" | "finish"
  >("start");

  const [params] = useSearchParams();

  const { api } = useApiWebCheckinUser();
  const { logo, colorsTheme } = useTheme();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [controlRender, setControlRender] = React.useState<boolean>(false);

  const { theme, containerGlobalRef, notify } = useGlobalWebCheckinUser();

  const [reservation, setReservation] = React.useState<IReservation | null>(
    null
  );

  const handleSave = useCallback(
    async () => {
      setLoading(true);
      try {
        await api.post("/check-out", {
          reservation_stays_id: reservation?.id,
        });

        notify("Check-out realizado com sucesso!", "success");
        setStep("finish");
      } catch (e) {
        notify(
          "Problema ao realizar o check-in! Tente novamente mais tarde",
          "alert"
        );
      }

      setLoading(false);
    },
    [reservation]
  );

  const StartChildren = (
    <Start
      onSave={(reservation) => {
        const correctReservation = reservation as IReservation;
        correctReservation.guests = correctReservation.guests.sort((a, b) =>
          a.primary ? -1 : 1
        );
        setReservation(correctReservation);
        setStep("confirmation-steps");
      }}
      defaultReservationId={params.get("reservation_id") ?? ""}
      defaultCheckInDate={params.get("date") ?? ""}
    />
  );

  return (
    <Container>
      <div style={{ marginTop: 30, marginBottom: 10 }}>
        <img src={logo} style={{
          width: '100%',
          maxHeight: '60px',
          height: 'auto',
          objectFit: 'contain'
        }}
        />
      </div>
      <Content
        ref={containerGlobalRef}
        style={{
          position: "relative",
          overflow: "hidden",
          display: loading ? "none" : "flex",
        }}
      >
        {step === "start" && !controlRender && StartChildren}
        {step === "start" && controlRender && StartChildren}
        {step === "confirmation-steps" && (
          <ConfirmationStep
            reservation={reservation as any}
            onSave={handleSave}
          />
        )}
        {step === "finish" && (
          <Finish reservation={reservation as IReservation} />
        )}
      </Content>
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
          }}
        >
          <MyCircularProgress size={30} color={colorsTheme.secondary.light}/>
        </div>
      )}

      <a href="https://webcheckin.app/" target="_blank" rel="noopener noreferrer">
        <IconPowered theme={theme} />
      </a>
    </Container>
  );
};
